import Vue from "vue";
import Vuex from "vuex";
// import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    filters: [],
    items: [],
    filtersByCategory: [], //Static Data
    errors: [],
    sort: {
        sortBy: 'sortableTitle',
        sortDirection: 'ASC'
    }
  },
  mutations: {
    init(state, payload) {
      state.filters = payload.filters;
      state.items = payload.items;

      state.items.forEach(i => {
        if(i.title != null) {
          i.sortableTitle = (i.title != null) ? i.title.toLowerCase() : '';
        }
      })

      state.filters.map(f => {
        //f.disabled = false;
        Vue.set(f, "disabled", false);
        //f.selected = false;
        Vue.set(f, "selected", false);
      });



      state.items.map(i => {
        //i.isExcluded = false;
        Vue.set(i, "isExcluded", false);
        //state.filteredItems.push(i);
      });

      state.filters.sort( function( a, b ){
        return ( ( a.categoryName == b.categoryName ) ? 0 : ( ( a.categoryName > b.categoryName ) ? 1 : -1 ) );
      }.bind(this));


      //group selected filters by category
      state.filters.map(f => {
        //find category object
        let category = state.filtersByCategory.find(function(c) {
          return c.name == f.categoryName;
        });

        if(!category){
          //category doesn't exist in structure, create it
          state.filtersByCategory.push({name: f.categoryName, filters: []});

          //assign the new object in the array to "category"
          category = state.filtersByCategory.find(function(c) {
            return c.name == f.categoryName;
          });
        }
        //add the filter to the filters array for the specified category
        category.filters.push(f);
      });





    },
    applySort(state, payload) {

        if(payload) {
            state.sort.sortBy = payload.sortBy;
            state.sort.sortDirection = payload.sortDirection;
        }


        state.items.sort( function( a, b ){
            if( state.sort.sortDirection == 'ASC' ){
                return ( ( a[state.sort.sortBy] == b[state.sort.sortBy] ) ? 0 : ( ( a[state.sort.sortBy] > b[state.sort.sortBy] ) ? 1 : -1 ) );
            }

            if( state.sort.sortDirection == 'DESC' ){
                return ( ( a[state.sort.sortBy] == b[state.sort.sortBy] ) ? 0 : ( ( a[state.sort.sortBy] < b[state.sort.sortBy] ) ? 1 : -1 ) );
            }
        }.bind(this));

    },
    filterFilters(state){
       // for buy now page, show all filters that the products have.
        let filters = []
         state.items.map(f => {
           f.tags.map(t => {
             if(filters.indexOf(t) <= 0){
               filters.push(t)
             }
           })
        })
        console.log('item filter ids', filters)
        let newFilters = []
        state.filters.map(f => {
          if(filters.includes(f.id)){
            newFilters.push(f)
          }
        })
        console.log('filter objects: ', newFilters)
        state.filters = newFilters
    },
    applyFilters(state, payload) {
      /* Update Selected Filters */
      // payload.value /* filter id */
      // payload.checked /* filter selected */

      if(payload != null){
        //find corresponding filter and update it
        let updatedFilter = state.filters.find(function(filterItem) {
          return filterItem.id == payload.value;
        });
        console.log(payload);
        updatedFilter.selected = payload.checked;
      }

      
      /* Apply Filter to Items */            

      //reset all items to be included
      state.items.forEach(item => {
        item.isExcluded = false;
      });

      //reset all filters to enabled
      state.filters.forEach(filterItem => {
        filterItem.disabled = false;
      });

      //check to see if any of the filters are selected.
      let anyFiltersSelected = state.filters.some(function(filterItem) {
        return filterItem.selected;
      });

      if(anyFiltersSelected)
      {
        //At least one filter is selected, apply filtering.
        state.items.forEach(item => { //item loop
          item.isExcluded = !state.filtersByCategory.every(function(filterCategory) { //filter category loop
            //All categories must match (and logic)
            let categoryMatch = false;

            let anySelectedInCategory = filterCategory.filters.some(function(filterItem) {
              return filterItem.selected;
            });
            
            if(anySelectedInCategory) {
              //At least one filter in this category is selected. See if any of the items are a match
              categoryMatch = filterCategory.filters.some(function(filterItem) {
                //if at least one filter in category matches return true
                return filterItem.selected && item.tags.some(function (itemTag) {
                  //see if item has this tag
                  return itemTag == filterItem.id;
                })
              });              
            }
            else{
              //No items in category are selected, this is equivalent to all items in category being selected. Return this as being a match
              categoryMatch = true;
            }
            return categoryMatch;
          }); //end filter category loop
        }); //end item loop

        //Determine what filters should still be enabled


        /* Update Filters */
        // let unUsedCategoryNames = [];
        // state.filtersByCategory.forEach(function(filtCategory) {
        //   if(filtCategory.filters.some(function(filt) {
        //     return filt.selected;
        //   })) {
        //     unUsedCategoryNames.push(filtCategory.name);
        //   }
        // })

        let validFilterIds = []; //list of unqique filter ids/tags for the result set
        state.items.forEach(function(item) {
          if(!item.isExcluded) {
            item.tags.forEach(function(tag) {
              if(validFilterIds.indexOf(tag) < 0){
                validFilterIds.push(tag);
              }
            });
          }
        });

        //Set disabled flag for any filter that's not in the list
        state.filters.forEach(function(filterItem){
            if(validFilterIds.indexOf(filterItem.id) < 0 && !filterItem.selected) {
              //no items with matching tags and not selected, disable filter item
              filterItem.disabled = true;
          }
        });

        //For each disabled filter, test to see if selecting would match an excluded element. If so, re-enabled it.
        let disabledFilters = state.filters.filter(filterItem => filterItem.disabled);
        let excludedItems = state.items.filter(item => item.isExcluded);
        disabledFilters.forEach(disabledFilterItem => {
          excludedItems.forEach(item => {
            
            let isExcluded = !state.filtersByCategory.every(function(filterCategory) {
              //All categories must match (and logic)
              let categoryMatch = false;

              let anySelectedInCategory = filterCategory.filters.some(function(filterItem) {
                //operate under the premise that the disabledFilterItem is actually selected.
                let isSelected = false;
                if(filterItem.id == disabledFilterItem.id){
                  isSelected = true;
                }
                else {
                  isSelected = filterItem.selected
                }
                return isSelected;
              });

              if(anySelectedInCategory) {
                categoryMatch = filterCategory.filters.some(function(filterItem) {
                  let isSelected = false;
                  //operate under the premise that the current disabled filter item is selected
                  if(disabledFilterItem.id == filterItem.id){
                    isSelected = true;
                  }
                  else{
                    isSelected == filterItem.selected;
                  }

                  //if at least one filter in category matches return true.
                  return isSelected && item.tags.some(function (itemTag) {
                    //see if item has this tag
                    return itemTag == filterItem.id;
                  })
                });
              }
              else{
                //No items in category are selected, this is equivalent to all items in category being selected. Return this as being a match
                categoryMatch = true;
              }
              return categoryMatch;
            });

            if(!isExcluded) {
              //enabling this filter would include this item in the results. Re-enable this filter item
              disabledFilterItem.disabled = false;
            }

          });
        });
      }
    }
  },
  actions: {
    initialize(context, payload) {
      context.commit("init", payload);
    },
    applyFilters(context, payload) {
      context.commit("applyFilters", payload);
    },
    applySort(context, payload) {
      context.commit("applySort", payload);
    },
    filterFilters(context){
      context.commit('filterFilters');
    }
  }
});

